export default __webpack_public_path__ + "static/media/logo-circle-fourthoption.d00bdb5c.png";